import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { SelectCustom } from '../../../../../../../common/selectCustom'
import { selectListFilterTimeHistoricalChange } from '../../../../store/slice'
import { formatListFilterTime } from '../helper'
import { RiskComponentAnalysisTime } from './RiskComponentAnalysisTime'

const SelectTimeRiskComponentAnalysis = ({
  title = '',
  setting,
  keySetting,
  setValue,
}) => {
  const listFilterTime = useSelector(selectListFilterTimeHistoricalChange)
  const options = formatListFilterTime(listFilterTime, setting?.timeFrequency)

  const chooseItem = (value) => {
    setValue && setValue(`setting.${keySetting}`, value)
  }

  useEffect(() => {
    if (options.length > 0 && setValue) {
      const currentValue = setting[keySetting]
      const firstOption = keySetting === 'basePeriod' ? options[0] : options[1]
      const valueExists = options.some(
        (option) =>
          option.value === currentValue?.value || option === currentValue,
      )
      if (!valueExists) {
        setValue(`setting.${keySetting}`, firstOption)
      }
    }
  }, [setting?.timeFrequency, options, setting, keySetting, setValue])

  return (
    <RiskComponentAnalysisTime>
      <div className="dFlex alignItemsCenter" style={{ gap: 12 }}>
        <Translate value={title} style={{ width: 150 }} />
        <SelectCustom
          activeItem={setting[keySetting] || options[0]}
          data={options}
          chooseItem={chooseItem}
          style={{
            marginRight: 4,
            fontSize: 12,
            padding: '4px 12px',
            minWidth: 100,
          }}
          disabled={!options.length}
        />
      </div>
      {!options.length ? (
        <div
          style={{
            color: 'red',
            marginTop: 4,
          }}
        >
          <Translate value="riskComponentAnalysis.textSelectCompany" />
        </div>
      ) : null}
    </RiskComponentAnalysisTime>
  )
}

export default SelectTimeRiskComponentAnalysis
